import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { providerOrganisationsGroupedByProviderSelector } from "./providerOrganisationsGroupedByProviderSelector";
import { providerOrganisationsByProviderAndOrgCombiner } from "./utils/helpers";

export const providerOrganisationsGroupedByProviderAndOrgSelector =
  createDraftSafeSelector(
    [providerOrganisationsGroupedByProviderSelector],
    providerOrganisationsByProviderAndOrgCombiner,
  );
